@for (blok of content(); track blok) {
	<div class="section-inner">
		<div class="section-spacing">
			@if (components) {
				<ndc-dynamic
					[ndcDynamicComponent]="components[blok['component']]"
					[ndcDynamicInputs]="blok"
				/>
			}
		</div>
	</div>
}
